import Api from 'App/api'
import getProjectName from 'portal-modules/common/utils/get-project-name'

const tenantOrGroupUsers =
  'rh' === getProjectName() ? 'group_users' : 'tenant_users'

export const getUsers = Api.get({
  controller: tenantOrGroupUsers,
  action: 'listWithSettings',
})

export const addUserDetails = Api.post({
  controller: tenantOrGroupUsers,
  action: 'add',
})

export const addUserPermissions = Api.post({
  controller: tenantOrGroupUsers,
  action: 'savePermissions',
})

export const sendInvite = Api.post({
  controller: tenantOrGroupUsers,
  action: 'sendInvitation',
})

export const deleteUser = Api.post({
  controller: tenantOrGroupUsers,
  action: 'delete',
})

export const uploadProfileImage = Api.post({
  controller: tenantOrGroupUsers,
  action: 'uploadProfileImage',
})

export const updateUserDetails = Api.post({
  controller: tenantOrGroupUsers,
  action: 'update',
})

export const sendResetPassword = Api.post({
  controller: tenantOrGroupUsers,
  action: 'resetPassword',
  forceBaseUrl: 1,
})
